export default "__VITE_ASSET__Dkg0rMs7__"